export const cbitSupportEmail = 'support@crossborderit.com';

